(() => {
  async function boot(){
    const page=document.querySelector('[data-mike-page]'),root=document.querySelector('.dl'),node=document.querySelector('[data-mike-commerce-config]');
    if(!page||!root||!node||root.__dlMikeCommerce)return;
    const config=JSON.parse(node.textContent),words=document.querySelector('[data-mike-commerce-words]').dataset;
    if(!config.bundle?.variants){try{const response=await fetch('/products/droplit-mike-bundle.js',{cache:'no-store'});if(response.ok)config.bundle=await response.json();}catch{}}
    const money=n=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:config.currency||'USD'}).format(n/100);
    const valid=(p,tag)=>p&&Array.isArray(p.tags)&&p.tags.includes(tag)&&!['build-your-own-hat','extra-custom-drop'].includes(p.handle);
    function quote(){
      const key=root.dataset.hat||'white';
      const product=config.bundle;
      const bundle=valid(product,'droplit-mike-bundle')?product.variants.find(v=>v.title.trim().toLowerCase()===key):null;
      const slots=root.__dlSlots||[];
      const extras=[2,3].filter(i=>slots[i]).map(index=>{
        const artist=!!slots[index].mikeDesignId,p=artist?config.artistExtra:config.standardExtra;
        const variant=valid(p,artist?'droplit-mike-addon':'droplit-standard-addon')?p.variants.find(v=>v.available):null;
        return {index,variant};
      });
      return {bundle,extras,ready:!!bundle?.available&&extras.every(e=>e.variant?.available),total:bundle?bundle.price+extras.reduce((sum,e)=>sum+(e.variant?.price||0),0):null};
    }
    const status=document.querySelector('[data-mike-commerce-status]');
    root.__dlMikeCommerce={quote,enabled:config.enabled,unavailable:words.unavailable};
    if(config.enabled)status.hidden=true;
    const set=(el,value)=>{if(el&&el.textContent!==value)el.textContent=value;};
    function refresh(){
      const q=quote(),label=q.total!==null?money(q.total):money(3999);
      page.querySelectorAll('[data-mike-price],[data-mike-sticky-price]').forEach(el=>set(el,label));
      set(root.querySelector('[data-total]'),label);
      set(root.querySelector('.dl-builder-sale-price .sale'),q.bundle?money(q.bundle.price):money(3999));
      root.querySelectorAll('.dl-builder-sale-price .compare').forEach(el=>el.hidden=true);
      root.querySelector('.dl-builder-sale-price')?.removeAttribute('aria-label');
      root.querySelectorAll('[data-variants] option').forEach(o=>{
        const key=o.dataset.hatKey||o.textContent.split(' — ')[0].trim().toLowerCase();
        const v=valid(config.bundle,'droplit-mike-bundle')?config.bundle.variants.find(v=>v.title.toLowerCase()===key):null;
        const original=o.textContent.split(' — ')[0];set(o,original+' — '+(v?money(v.price):money(3999)));
      });
      const paragraphs=root.querySelectorAll('.buy>p');if(paragraphs[1])set(paragraphs[1],words.extras);
      root.querySelectorAll('.summary small').forEach(el=>{if(el.textContent.startsWith('+$')||el.dataset.mikeAddon){el.dataset.mikeAddon='1';set(el,words.addon);}});
      root.querySelectorAll('[data-add]>span,[data-add-bottom]>span').forEach(el=>{if(!config.enabled)set(el,words.review);});
      if(!config.enabled)set(status,words.testing);
    }
    window.addEventListener('click',event=>{
      if(!(event.target instanceof Element)||!event.target.closest('[data-add],[data-add-bottom]')||!root.contains(event.target))return;
      const q=quote();
      if(!config.enabled||!q.ready){
        event.preventDefault();event.stopImmediatePropagation();
        const slots=root.__dlSlots||[];
        const ready=slots[0]?.mikeDesignId&&slots[1]&&root.dataset.dlSaved1==='1'&&root.dataset.dlSaved2==='1'&&root.querySelector('[data-rights]')?.checked;
        set(status,!config.enabled?(ready?words.reviewed:words.complete):words.unavailable);
        status.focus();status.scrollIntoView({block:'center',behavior:'smooth'});
      }
    },true);
    let queued=false;
    const queue=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;refresh();});};
    new MutationObserver(queue).observe(root,{subtree:true,childList:true,characterData:true});
    root.addEventListener('change',queue);root.addEventListener('click',queue);root.addEventListener('droplit:drop-saved',queue);
    refresh();
  }
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',boot,{once:true}):boot();
  document.addEventListener('shopify:section:load',boot);
})();
